import PageComp from "@/components/page/index.vue";
import SearchComp from "@/components/search/index.vue";
import MainTempComp from "@/components/mainTemp/index.vue";
const compList = [PageComp, SearchComp, MainTempComp];
export default (app) => {
    compList.forEach((comp) => {
        app.component(comp.name, comp);
    });
};
